import navigations from "./navigations.json";
import footer from "./footer.json";
import header from "./header.json";
import homepage from "./views/homepage.json";
import download from "./views/download.json";
import contribute from "./views/contribute.json";

export const en = {
  navigations: navigations,
  header: header,
  footer: footer,
  views: {
    homepage: homepage,
    download: download,
    contribute: contribute
  },
};
